 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"blocks.Base":"blocks.Base","blocks.graph":"blocks.graph","blocks.Line":"blocks.Line","blocks.Bar":"blocks.Bar","blocks.Pie":"blocks.Pie","blocks.BarHorizontal":"blocks.BarHorizontal","blocks.Content":"blocks.Content","blocks.overlay":"blocks.overlay","global":"global","blocks.ButtonToDownloads":"blocks.ButtonToDownloads","FlexibleContentBlock":"FlexibleContentBlock","blocks.ButtonDownload":"blocks.ButtonDownload","blocks.DownloadCenterLayout":"blocks.DownloadCenterLayout","ruter":"ruter","blocks.parts":"blocks.parts","npm.chart.js":"npm.chart.js","blocks.Block":"blocks.Block","blocks.ArticleMenu":"blocks.ArticleMenu","blocks.ArticleSingle":"blocks.ArticleSingle","blocks.ArticlesList":"blocks.ArticlesList","blocks.BaseDynamicBlock":"blocks.BaseDynamicBlock","blocks.ResponsiveTabs":"blocks.ResponsiveTabs","blocks.BlobHero":"blocks.BlobHero","blocks.wysiwyg":"blocks.wysiwyg","blocks.Text":"blocks.Text","blocks.CookiebotConsentPage":"blocks.CookiebotConsentPage","blocks.FileDownloads":"blocks.FileDownloads","blocks.FpKeyNumbers":"blocks.FpKeyNumbers","blocks.GraphSideBySide":"blocks.GraphSideBySide","blocks.ImageAndQuote":"blocks.ImageAndQuote","blocks.ImageBanner":"blocks.ImageBanner","blocks.KeyNumbers":"blocks.KeyNumbers","blocks.Media":"blocks.Media","blocks.TextAndMedia":"blocks.TextAndMedia","blocks.Timeline":"blocks.Timeline","blocks.Person":"blocks.Person","blocks.people":"blocks.people","blocks.People":"blocks.People","blocks.Summary":"blocks.Summary","blocks.Table":"blocks.Table","blocks.VideoHero":"blocks.VideoHero","blocks.default":"blocks.default","blocks.GraphBar":"blocks.GraphBar","blocks.GraphLine":"blocks.GraphLine","blocks.GraphPie":"blocks.GraphPie","blocks.Tooltip":"blocks.Tooltip","blocks.ArticleHeader":"blocks.ArticleHeader","blocks.Notes":"blocks.Notes","blocks.DownloadCenterButtons":"blocks.DownloadCenterButtons","blocks.Header":"blocks.Header","blocks.HeaderLink":"blocks.HeaderLink","blocks.Homepage":"blocks.Homepage","FlexibleContentBlockBase":"FlexibleContentBlockBase","blocks.PlainHeader":"blocks.PlainHeader","blocks.Row":"blocks.Row","blocks.Slider":"blocks.Slider","blocks.article":"blocks.article","blocks.table":"blocks.table","blocks.content":"blocks.content","blocks.ToggleSwitch":"blocks.ToggleSwitch","blocks.Link":"blocks.Link","blocks.downloads":"blocks.downloads","pages":"pages","npm.foundation.js":"npm.foundation.js"}[chunkId]||chunkId) + "-legacy." + {"blocks.Base":"26183918","blocks.graph":"fe2604f9","blocks.Line":"cfb023cd","blocks.Bar":"a77e703e","blocks.Pie":"4fd4b271","blocks.BarHorizontal":"829a59b0","chunk-067c54e2":"4814cf34","blocks.Content":"0f1d5e5a","blocks.overlay":"ef8a8cda","global":"923f85d8","blocks.ButtonToDownloads":"cc424ebf","FlexibleContentBlock":"26a738a9","chunk-2d216214":"72523fad","chunk-281d4b7c":"6018004c","blocks.ButtonDownload":"dac31cb8","blocks.DownloadCenterLayout":"abee1dc3","chunk-11178d08":"0353c962","chunk-010b08d6":"e44552c3","ruter":"5cb630f6","blocks.parts":"cbf1f43b","npm.chart.js":"2a1e8ab5","blocks.Block":"5f4d1d5c","chunk-5237a36c":"11c93e5d","chunk-54588c50":"ae8fc208","blocks.ArticleMenu":"12fb6f46","blocks.ArticleSingle":"9d5d81a8","blocks.ArticlesList":"50f86509","blocks.BaseDynamicBlock":"948cc3ee","blocks.ResponsiveTabs":"746e807b","chunk-5af7459e":"50aa0ebf","blocks.BlobHero":"1b8100ea","blocks.wysiwyg":"1b5732e6","blocks.Text":"e240478a","blocks.CookiebotConsentPage":"435ffdfc","blocks.FileDownloads":"4d40e1bb","blocks.FpKeyNumbers":"04eb44ba","blocks.GraphSideBySide":"042be893","blocks.ImageAndQuote":"6a71b6a1","blocks.ImageBanner":"63f936cf","blocks.KeyNumbers":"6fc33596","blocks.Media":"a901ec29","blocks.TextAndMedia":"164a9211","blocks.Timeline":"2d3ec662","blocks.Person":"599f209c","blocks.people":"ab796d93","blocks.People":"485f1867","blocks.Summary":"c68cdd71","blocks.Table":"c805d2ec","blocks.VideoHero":"0bd85edd","blocks.default":"43f85987","blocks.GraphBar":"2fc3bde1","blocks.GraphLine":"630c99e3","blocks.GraphPie":"aaffa31e","blocks.Tooltip":"00ff89a4","blocks.ArticleHeader":"2217fc7d","blocks.Notes":"21f212c5","chunk-b39e8468":"3a1c6e57","blocks.DownloadCenterButtons":"0a963189","blocks.Header":"d009f0c5","blocks.HeaderLink":"87dc05af","blocks.Homepage":"973b0bc0","FlexibleContentBlockBase":"ea9bd192","chunk-c3a65e1e":"44ad79fe","chunk-2d0d056d":"0e2557c9","chunk-2d0de528":"5abcfb27","blocks.PlainHeader":"1f83a713","blocks.Row":"5c8cf041","blocks.Slider":"c6e3162e","chunk-2d0ae5a4":"85cb3aa0","blocks.article":"5d2fc11d","chunk-2d22cc69":"6e8cb9cb","blocks.table":"3778081e","blocks.content":"3f3963fb","chunk-93a01390":"970e6122","blocks.ToggleSwitch":"845190f5","chunk-2d0e5d9e":"e2f1ecc9","blocks.Link":"15d391e3","blocks.downloads":"a020e99f","chunk-2d0cb76d":"91d8a65f","pages":"01ceebc2","npm.foundation.js":"cf7bde88","chunk-0cb6d016":"6e44e6bb"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"blocks.graph":1,"chunk-067c54e2":1,"blocks.overlay":1,"global":1,"blocks.DownloadCenterLayout":1,"chunk-010b08d6":1,"ruter":1,"blocks.parts":1,"blocks.ArticleMenu":1,"blocks.ArticlesList":1,"blocks.ResponsiveTabs":1,"blocks.BlobHero":1,"blocks.wysiwyg":1,"blocks.Text":1,"blocks.CookiebotConsentPage":1,"blocks.FileDownloads":1,"blocks.FpKeyNumbers":1,"blocks.GraphSideBySide":1,"blocks.ImageAndQuote":1,"blocks.ImageBanner":1,"blocks.KeyNumbers":1,"blocks.Media":1,"blocks.TextAndMedia":1,"blocks.Timeline":1,"blocks.people":1,"blocks.People":1,"blocks.Summary":1,"blocks.VideoHero":1,"blocks.default":1,"blocks.ArticleHeader":1,"blocks.Notes":1,"blocks.DownloadCenterButtons":1,"blocks.Homepage":1,"blocks.Slider":1,"blocks.article":1,"blocks.table":1,"blocks.content":1,"blocks.downloads":1,"pages":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"blocks.Base":"blocks.Base","blocks.graph":"blocks.graph","blocks.Line":"blocks.Line","blocks.Bar":"blocks.Bar","blocks.Pie":"blocks.Pie","blocks.BarHorizontal":"blocks.BarHorizontal","blocks.Content":"blocks.Content","blocks.overlay":"blocks.overlay","global":"global","blocks.ButtonToDownloads":"blocks.ButtonToDownloads","FlexibleContentBlock":"FlexibleContentBlock","blocks.ButtonDownload":"blocks.ButtonDownload","blocks.DownloadCenterLayout":"blocks.DownloadCenterLayout","ruter":"ruter","blocks.parts":"blocks.parts","npm.chart.js":"npm.chart.js","blocks.Block":"blocks.Block","blocks.ArticleMenu":"blocks.ArticleMenu","blocks.ArticleSingle":"blocks.ArticleSingle","blocks.ArticlesList":"blocks.ArticlesList","blocks.BaseDynamicBlock":"blocks.BaseDynamicBlock","blocks.ResponsiveTabs":"blocks.ResponsiveTabs","blocks.BlobHero":"blocks.BlobHero","blocks.wysiwyg":"blocks.wysiwyg","blocks.Text":"blocks.Text","blocks.CookiebotConsentPage":"blocks.CookiebotConsentPage","blocks.FileDownloads":"blocks.FileDownloads","blocks.FpKeyNumbers":"blocks.FpKeyNumbers","blocks.GraphSideBySide":"blocks.GraphSideBySide","blocks.ImageAndQuote":"blocks.ImageAndQuote","blocks.ImageBanner":"blocks.ImageBanner","blocks.KeyNumbers":"blocks.KeyNumbers","blocks.Media":"blocks.Media","blocks.TextAndMedia":"blocks.TextAndMedia","blocks.Timeline":"blocks.Timeline","blocks.Person":"blocks.Person","blocks.people":"blocks.people","blocks.People":"blocks.People","blocks.Summary":"blocks.Summary","blocks.Table":"blocks.Table","blocks.VideoHero":"blocks.VideoHero","blocks.default":"blocks.default","blocks.GraphBar":"blocks.GraphBar","blocks.GraphLine":"blocks.GraphLine","blocks.GraphPie":"blocks.GraphPie","blocks.Tooltip":"blocks.Tooltip","blocks.ArticleHeader":"blocks.ArticleHeader","blocks.Notes":"blocks.Notes","blocks.DownloadCenterButtons":"blocks.DownloadCenterButtons","blocks.Header":"blocks.Header","blocks.HeaderLink":"blocks.HeaderLink","blocks.Homepage":"blocks.Homepage","FlexibleContentBlockBase":"FlexibleContentBlockBase","blocks.PlainHeader":"blocks.PlainHeader","blocks.Row":"blocks.Row","blocks.Slider":"blocks.Slider","blocks.article":"blocks.article","blocks.table":"blocks.table","blocks.content":"blocks.content","blocks.ToggleSwitch":"blocks.ToggleSwitch","blocks.Link":"blocks.Link","blocks.downloads":"blocks.downloads","pages":"pages","npm.foundation.js":"npm.foundation.js"}[chunkId]||chunkId) + "." + {"blocks.Base":"31d6cfe0","blocks.graph":"762b6dfb","blocks.Line":"31d6cfe0","blocks.Bar":"31d6cfe0","blocks.Pie":"31d6cfe0","blocks.BarHorizontal":"31d6cfe0","chunk-067c54e2":"fbc9e114","blocks.Content":"31d6cfe0","blocks.overlay":"23995629","global":"7a593ac0","blocks.ButtonToDownloads":"31d6cfe0","FlexibleContentBlock":"31d6cfe0","chunk-2d216214":"31d6cfe0","chunk-281d4b7c":"31d6cfe0","blocks.ButtonDownload":"31d6cfe0","blocks.DownloadCenterLayout":"32d9d984","chunk-11178d08":"31d6cfe0","chunk-010b08d6":"9ff89083","ruter":"3a0e588d","blocks.parts":"a86230b1","npm.chart.js":"31d6cfe0","blocks.Block":"31d6cfe0","chunk-5237a36c":"31d6cfe0","chunk-54588c50":"31d6cfe0","blocks.ArticleMenu":"e54a0bcd","blocks.ArticleSingle":"31d6cfe0","blocks.ArticlesList":"31cbbf47","blocks.BaseDynamicBlock":"31d6cfe0","blocks.ResponsiveTabs":"dca83830","chunk-5af7459e":"31d6cfe0","blocks.BlobHero":"69487ff2","blocks.wysiwyg":"c62330c4","blocks.Text":"ba3e93de","blocks.CookiebotConsentPage":"df05e749","blocks.FileDownloads":"61d41a2c","blocks.FpKeyNumbers":"1402feae","blocks.GraphSideBySide":"9262c745","blocks.ImageAndQuote":"e35c63a1","blocks.ImageBanner":"cb20b4ba","blocks.KeyNumbers":"728b151e","blocks.Media":"de89db6b","blocks.TextAndMedia":"a5cdfce2","blocks.Timeline":"3298c25d","blocks.Person":"31d6cfe0","blocks.people":"6ff191d0","blocks.People":"63f37d83","blocks.Summary":"b8b9f951","blocks.Table":"31d6cfe0","blocks.VideoHero":"2170c606","blocks.default":"2170c606","blocks.GraphBar":"31d6cfe0","blocks.GraphLine":"31d6cfe0","blocks.GraphPie":"31d6cfe0","blocks.Tooltip":"31d6cfe0","blocks.ArticleHeader":"fb3eb014","blocks.Notes":"acc8cda4","chunk-b39e8468":"31d6cfe0","blocks.DownloadCenterButtons":"a9e85fc0","blocks.Header":"31d6cfe0","blocks.HeaderLink":"31d6cfe0","blocks.Homepage":"3f323cb0","FlexibleContentBlockBase":"31d6cfe0","chunk-c3a65e1e":"31d6cfe0","chunk-2d0d056d":"31d6cfe0","chunk-2d0de528":"31d6cfe0","blocks.PlainHeader":"31d6cfe0","blocks.Row":"31d6cfe0","blocks.Slider":"55c8f164","chunk-2d0ae5a4":"31d6cfe0","blocks.article":"fe6c8aa7","chunk-2d22cc69":"31d6cfe0","blocks.table":"0523e898","blocks.content":"1d358f31","chunk-93a01390":"31d6cfe0","blocks.ToggleSwitch":"31d6cfe0","chunk-2d0e5d9e":"31d6cfe0","blocks.Link":"31d6cfe0","blocks.downloads":"73c4bc0c","chunk-2d0cb76d":"31d6cfe0","pages":"caf0cef2","npm.foundation.js":"31d6cfe0","chunk-0cb6d016":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/wp-content/themes/aarsrapport-2021/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"npm.core-js","npm.axios","npm.vue","npm.babel","npm.lodash","npm.webpack","npm.ambitiondev","npm.flatted","npm.process","npm.url-search-params-polyfill"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
